import { render, staticRenderFns } from "./buyNumber.vue?vue&type=template&id=304c11f6&"
import script from "./buyNumber.vue?vue&type=script&lang=js&"
export * from "./buyNumber.vue?vue&type=script&lang=js&"
import style0 from "./buyNumber.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports